import React from "react";
import SiteDocumentation from "./SiteDocumentation";

export default function XMQ_doc_load_balancer() {
    return <SiteDocumentation page="load-balancer"/>;
}
